import config from 'config';
import _ from 'underscore';
import Backbone from 'backbone';
import BootstrapData from './BootstrapData';
import {removeAccessToken, removeRefreshToken} from '../AuthToken';
import {remove as removeCookie} from 'js-cookie';

const Auth = Backbone.Model.extend({
    initialize: function() {
        this.event = BootstrapData('bootstrap-data-event');
    },

    connectWithLinkedin: function({success, error, updateToken}) {
        this.stopListening(Backbone, 'linkedin-connect-success');
        this.listenToOnce(Backbone, 'linkedin-connect-success', async function(data) {
            this.updateLinkedinToken(data, {success, error});
        });
        this.stopListening(Backbone, 'linkedin-connect-error');
        this.listenToOnce(Backbone, 'linkedin-connect-error', function(message) {
            error && error(message);
        });
        const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        const eventer = window[eventMethod];
        var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
        // Listen to message from child window
        eventer(messageEvent, function(e) {
            const data = e && e.data;
            const authSuccess = data && !!data.id;
            // Check if origin is proper
            if ( e.origin !== `https://${config.hostUrl}` ){
                return;
            }
            if (authSuccess){
                Backbone.trigger('linkedin-connect-success', data);
            } else {
                const message = e.data && e.data.message || 'There was a problem getting your profile data from linkedin';
                Backbone.trigger('linkedin-connect-error', message);
            }
        }, false);
        return window.open(`https://${config.hostUrl}/auth/linkedin`, 'LinkedInAuth', 'height=645,width=700,status=yes,toolbar=no,menubar=no,location=no');
    },

    updateLinkedinToken: function(data, options) {
        let success = function() {
            options.success && options.success(data);
        };

        let error = function(data) {
            let errorCode = (data.error && data.error['error-code']) || 0;
            options.error && options.error(errorCode);
        };
        const body = {
            refreshToken: data.refreshToken,
            socialNetwork: 'linkedin',
            token: data.token,
            secret: 'SECRET_PLACEHOLDER'
        };

        Backbone.ajax({
            url: '/api/v2/userProfile/socialNetwork',
            method: 'POST',
            data: body,
            success,
            error
        });
    },

    removeBizzaboToken: async function() {
        await removeRefreshToken();
        removeCookie('x-bz-vote-id');
        removeCookie(config.previewCookieName, {
            domain: window.location.hostname
        });
        removeCookie('x-bz-vote-id');
    },

    signOut: async function() {
        return this.removeBizzaboToken();
    }
});
export default Auth;
